import { dateTime, dateToISO } from '../../shared/packages/dateTime';
import { fieldNames } from '../../shared/configs/acceptanceForm';
import { mapToPayload } from './mapToPayload';

const toBackend = {
  [fieldNames.deskDateRange.fromDate]: dateToISO,
  [fieldNames.deskDateRange.toDate]: dateToISO,
};

const toForm = {
  [fieldNames.deskDateRange.fromDate]: toDateTime,
  [fieldNames.deskDateRange.toDate]: toDateTime,
};

export const mapDeskDateRanges = (dates) => mapToPayload(dates, toBackend);
export const mapDeskDateRangesToForm = (dates) => mapToPayload(dates, toForm);

function toDateTime(value) {
  return dateTime(value);
}
